export default "__VITE_ASSET__BToOO_wK__"